/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailShipping_viewer = {
    readonly relevantShipping: {
        readonly quoteRequestStatus: string | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingInfoLink_viewer">;
    readonly " $refType": "PdpSharedDetailShipping_viewer";
};
export type PdpSharedDetailShipping_viewer$data = PdpSharedDetailShipping_viewer;
export type PdpSharedDetailShipping_viewer$key = {
    readonly " $data"?: PdpSharedDetailShipping_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailShipping_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedDetailShipping_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "itemId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "relevantShipping",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        },
        {
          "kind": "Variable",
          "name": "itemId",
          "variableName": "itemId"
        }
      ],
      "concreteType": "RelevantShippingInfo",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "quoteRequestStatus",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfoLink_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '799785263ca3ea29b124a6952a40b781';
export default node;
